import { GetterTree } from 'vuex'
import { State } from './'

const getters: GetterTree<any, any> = {
	data(state: State): any {
		return state.data
	},
	currentScreen(state: State): number {
		return state.currentScreen
	},
	onAnswerScreen(state: State): boolean {
		return state.onAnswerScreen
	},
	userOnResultScreen(state: State): boolean {
		return state.userOnResultScreen
	},
	userChoices(state: State): any[] {
		return state.userChoices
	},
	randomizedOptions(state: State): any[] {
		return state.randomizedOptions
	},
	formInputValues(state: State): { [key: number]: { questionId: number, answers: { [key: string]: string } } } {
		return state.formInputValues
	},
	visitedQuestions(state: State): number[] {
		return state.visitedQuestions
	}
}

export default getters
